import * as z from "zod";

export const splitWorkOrder = {
  name: "splitWorkOrder" as const,
  input: z.object({
    workOrderId: z.string(),
    splitQuantity: z.number().int().positive(),
  }),
  output: z.object({ newWorkOrderId: z.string() }),
};
